var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUmbrellaCheckMark = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0908 47.1458C25.0908 47.6392 24.6895 48.0396 24.195 48.0396C23.7005 48.0396 23.2992 47.6392 23.2992 47.1458V39.1018H19.7158V47.1458C19.7158 49.6109 21.7261 51.6147 24.195 51.6147C26.6639 51.6147 28.6742 49.6109 28.6742 47.1458V46.252H25.0908V47.1458Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.297 19.5299L23.2988 17.6512C23.2988 16.6627 22.4962 15.8636 21.5072 15.8636C20.5164 15.8636 19.7155 16.6627 19.7155 17.6512L19.7137 19.5299C10.7106 20.4219 3.67291 27.9672 3.59766 37.166C5.9752 35.0424 9.10524 33.7392 12.5488 33.7392C15.9978 33.7392 19.1332 35.0477 21.5125 37.1785C23.8901 35.0513 27.0183 33.7392 30.4655 33.7392C33.9091 33.7392 37.0373 35.0424 39.4167 37.166C39.3414 27.9636 32.3002 20.4201 23.297 19.5299Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.641 18L31.1904 8.62969L34.7953 5.05547L40.641 10.8516L51.5856 0L55.1904 3.57422L40.641 18Z",
    fill: "#D52B1E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUmbrellaCheckMark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/umbrella-check-mark.0d3cd77c426409486d25ffe941ff3437.svg";